export default "__VITE_ASSET__c602cbbc__"